// extracted by mini-css-extract-plugin
module.exports = {"dvoel57":"dvoel57"};